<template>
  <div class="workspace">
    <div class="section-heading">
      <h2>Reservations</h2>
    </div>
    <div class="r-sections">
      <div class="r-section" @click="tab = 0" :class="tab === 0 ? 'active' : ''"><i class="fas fa-calendar"></i> Reservations</div>
      <div class="r-section" @click="tab = 1" :class="tab === 1 ? 'active' : ''"><i class="fas fa-cog"></i> Settings</div>
    </div>
    <div v-if="tab === 0" class="r-table-cont">
      <div class="r-table-sections">
        <div class="r-table-section active">Upcoming</div>
        <div class="r-table-section">Past</div>
      </div>
      <div class="r-table">
        <div class="r-table-row head">
          <div class="r-table-col">Date</div>
          <div class="r-table-col">Party Size</div>
          <div class="r-table-col">Name</div>
          <div class="r-table-col">Email</div>
          <div class="r-table-col">Phone</div>
          <div class="r-table-col">Status</div>
          <div class="r-table-col">Details</div>
        </div>

        <reservation-list-item
          :updated="getReservations"
          v-if="displayList.length > 0"
          v-for="reservation in displayList"
          :reservation="reservation"
          :key="reservation._id"
        />
      </div>
      <div class="pagination flex" v-if="displayListSource.length > itemCount">
        <div @click="pageDown">&laquo;</div>
        <div class="cursor-pointer" @click="pageCount = page - 1" v-for="(page, index) in pageArray" :key="index" :class="page === pageCount + 1 ? 'active' : ''">{{page}}</div>
        <div @click="pageUp">&raquo;</div>
      </div>
    </div>
    <div v-else-if="tab === 1" class="r-settings">
      <div class="r-settings-section">
        <div class="r-section-head">Reservation Schedule</div>
        <div class="r-section-row">
          <div class="r-section-col">
            <h2>Days</h2>
            <div class="r-section-col-row">
              <label><input type="checkbox" v-model="weekdays['0'].enabled"> Monday</label>
            </div>
            <div class="r-section-col-row">
              <label><input type="checkbox" v-model="weekdays['1'].enabled"> Tuesday</label>
            </div>
            <div class="r-section-col-row">
              <label><input type="checkbox" v-model="weekdays['2'].enabled"> Wednesday</label>
            </div>
            <div class="r-section-col-row">
              <label><input type="checkbox" v-model="weekdays['3'].enabled"> Thursday</label>
            </div>
            <div class="r-section-col-row">
              <label><input type="checkbox" v-model="weekdays['4'].enabled"> Friday</label>
            </div>
            <div class="r-section-col-row">
              <label><input type="checkbox" v-model="weekdays['5'].enabled"> Saturday</label>
            </div>
            <div class="r-section-col-row">
              <label><input type="checkbox" v-model="weekdays['6'].enabled"> Sunday</label>
            </div>
          </div>
          <div class="r-section-col">
            <h2>Time</h2>
            <div class="r-section-col-row time" v-for="(time, index) in Object.keys(weekdays)" :key="index">
              <div><label>Start <input :disabled="!weekdays[time].enabled" v-model="weekdays[time].opening" type="time"></label></div>
              <div><label>End <input :disabled="!weekdays[time].enabled" type="time" v-model="weekdays[time].closing"></label></div>
            </div>
          </div>
        </div>
        <div class="r-save-button" @click="saveWeekDays">Save</div>
      </div>
      <div v-if="!refreshSeatings" class="r-settings-section">
        <div class="r-section-head">Seating Options</div>
        <div class="add-seating" @click="addSeating"><i class="fas fa-plus-circle"></i> Add Seating</div>
        <seating-item v-for="seating in visualSeatingList" :key="seating._id" :seating="seating" :finished="seatingSaved" />
      </div>
      <div class="r-settings-section">
        <div class="r-section-head"><i class="fas fa-info-circle"></i> Reservation Rules</div>
        <p>State your reservation rules below.</p>
        <textarea v-model="rules"></textarea>
        <div class="r-save-button" @click="editStore">Save</div>
      </div>
      <div class="r-settings-section">
        <div class="r-section-head"><i class="fas fa-exclamation-triangle"></i> Note To Your Guests</div>
        <p>Give important updates about your restaurant.</p>
        <textarea v-model="about"></textarea>
        <div class="r-save-button" @click="editStore">Save</div>
      </div>
      <div class="r-settings-section">
        <div class="r-section-head"><i class="fas fa-parking"></i> Parking Options</div>
        <p>Explain how your guests can park their vehicle around your restaurant</p>
        <textarea v-model="parking"></textarea>
        <div class="r-save-button" @click="editStore">Save</div>
      </div>
    </div>
  </div>
</template>

<script>
import SeatingItem from './reservations/SeatingItem'
import axios from '../axios'
import ReservationListItem from './reservations/ReservationListItem'
export default {
  name: 'Reservations',
  computed: {
    token () {
      return this.$store.state.api.reservationToken
    },
    reservationData () {
      return this.$store.state.api.reservationData
    },
    reservationStore: {
      get () {
        return this.$store.state.api.reservationStore
      },
      set (val) {
        this.$store.commit('api/SET_RESERVATION_STORE', val)
      }
    },
    visualSeatingList () {
      return JSON.parse(JSON.stringify(this.seatings)).reverse()
    },
    pageArray () {
      const array = JSON.parse(JSON.stringify(this.displayListSource))
      const page_array = []
      let i = 0
      const max_page = Math.floor(array.length / this.itemCount)
      const remainder = Math.round(array.length % this.itemCount)
      for (i = 0; i < max_page; i++) {
        page_array.push(parseInt(i) + 1)
      }
      if (remainder > 0) {
        page_array.push(page_array.length + 1)
      }
      return page_array
    },
    displayList () {
      const array = JSON.parse(JSON.stringify(this.displayListSource))
      return array.splice(this.pageCount * this.itemCount, this.itemCount)
    },
    displayListSource () {
      return this.reservations
    },
    max_page () {
      const array = JSON.parse(JSON.stringify(this.displayListSource))
      return Math.floor(array.length / this.itemCount)
    }
  },
  components: {
    axios,
    SeatingItem,
    ReservationListItem
  },
  watch: {
    refreshReservations () {
      if (this.refreshReservations) {
        setTimeout(() => {
          this.refreshReservations = false
        }, 500)
      }
    },
    refreshSeatings () {
      if (this.refreshSeatings) {
        setTimeout(() => {
          this.refreshSeatings = false
        }, 500)
      }
    }
  },
  data () {
    return {
      rules: '',
      about: '',
      parking: '',
      itemCount: 4,
      tab: 0,
      try: 0,
      pageCount: 0,
      reservations: [],
      seatings: [],
      refreshSeatings: false,
      refreshReservations: false,
      timetable: null,
      weekdays: {
        '0' : {
          enabled: true,
          closing: '21:00',
          opening: '10:00'
        },
        '1' : {
          enabled: true,
          closing: '21:00',
          opening: '10:00'
        },
        '2' : {
          enabled: true,
          closing: '21:00',
          opening: '10:00'
        },
        '3' : {
          enabled: true,
          closing: '21:00',
          opening: '10:00'
        },
        '4' : {
          enabled: true,
          closing: '21:00',
          opening: '10:00'
        },
        '5' : {
          enabled: true,
          closing: '21:00',
          opening: '10:00'
        },
        '6' : {
          enabled: true,
          closing: '21:00',
          opening: '10:00'
        }
      }
    }
  },
  methods: {
    loadData () {
      this.seatings = this.reservationStore.seatings
      const wd = Object.keys(this.reservationStore.timetable.weekdays).map(day_ => {
        const day = JSON.parse(JSON.stringify(this.reservationStore.timetable.weekdays[day_]))

        let o_h = day.opening.toString().substr(0, 2)

        if (o_h === '24') {
          o_h = '00'
        }

        let c_h = day.closing.toString().substr(0, 2)

        if (c_h === '24') {
          c_h = '00'
        }

        day.opening = `${o_h}:${day.opening.toString().substr(2)}`
        day.closing = `${c_h}:${day.closing.toString().substr(2)}`
        return day
      })
      this.weekdays = wd
      this.loadConfig()
      this.getReservations()
    },
    saveWeekDays () {
      const res_wd = {}
      Object.keys(this.weekdays).map(day_ => {
        const day = this.weekdays[day_]

        let h1 = day.opening.split(':')[0]
        const m1 = day.opening.split(':')[1]
        if (h1 === '00') {
          h1 = 24
        }
        day.opening = `${h1}${m1}`
        let h2 = day.closing.split(':')[0]
        if (h2 === '00') {
          h2 = 24
        }
        const m2 = day.closing.split(':')[1]
        day.closing = `${h2}${m2}`
        res_wd[day_] = day
        return day
      })
      const payload = {
        timetable: {
          weekdays: res_wd
        }
      }
      axios
        .put(`https://reservations.authorizelocal.com/api/store/${this.reservationStore.id}`, payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
          }
        })
        .then(response => {
          if (response.data.status) {
            this.getStore()
            this.$vs.notify({
              title: 'Success',
              text: 'Updated successfully',
              iconPack: 'feather',
              icon: 'icon-alert-check',
              color: 'success'
            })
          }
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Could not save seating',
            text: 'Seating error',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getTable (seating) {
      return {
        number: seating.count,
        seating: seating._id,
        hours: [],
        enabled: true,
        opening: 1000, // 10 am
        closing: 2100 // 9 pm
      }
    },
    prepend (value, array) {
      const newArray = array.slice()
      newArray.unshift(value)
      return newArray
    },
    seatingSaved () {
      this.refreshSeatings = true
      this.loadData()
    },
    addSeating () {
      const seating = {
        type: '',
        seats: 1,
        count: 1,
        store: this.reservationStore._id
      }
      this.seatings = [...this.seatings, seating]
    },
    pageUp () {
      if (this.pageCount < this.max_page) {
        this.pageCount += 1
      }
    },
    pageDown () {
      if (this.pageCount !== 0) {
        this.pageCount -= 1
      }
    },
    getReservations () {
      axios
        .get('https://reservations.authorizelocal.com/api/book', {
          headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
          }
        })
        .then(response => {
          if (response.data.status) {
            this.reservations = response.data.data
            // this.check = true
            this.refreshReservations = true

          }
        }).catch(() => {
          this.$vs.notify({
            title: 'Could not login to reservations',
            text: 'Login error',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    loadConfig () {
      const { rules, about, parking } = JSON.parse(JSON.stringify(this.reservationStore.details))
      this.rules = rules
      this.about = about
      this.parking = parking
    },
    getStore () {
      this.$validator.validateAll().then(result => {
        if (result) {
          axios
            .get(`https://reservations.authorizelocal.com/api/store/${this.reservationStore.id}`, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`
              }
            })
            .then(response => {
              if (response.data.status) {
                this.reservationStore = response.data.data
                this.loadData()
              }
            })
            .catch(() => {
              this.$vs.notify({
                title: 'Could not fetch store info',
                text: 'Store error',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
        }
      })
    },
    editStore () {
      const payload = {
        details: {
          rules: this.rules,
          about: this.about,
          parking: this.parking
        }
      }
      axios
        .put(`https://reservations.authorizelocal.com/api/store/${this.reservationStore.id}`, payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
          }
        })
        .then(response => {
          if (response.data.status) {
            this.getStore()
            this.$vs.notify({
              title: 'Success',
              text: 'Updated successfully',
              iconPack: 'feather',
              icon: 'icon-alert-check',
              color: 'success'
            })
          }
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Could not save seating',
            text: 'Seating error',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },
  mounted () {
    this.getStore()
  }
}
</script>

<style lang="scss">
.r-sections{
  display:flex;
  gap:15px;
  .r-section{
    border:1px solid #ccc;
    padding:5px 10px;
    cursor:pointer;
    color:#000;
    background-color:#fff;
    &:hover{
      background-color:#0070eb;
      color:#fff;
      border-color:#0063d0;
    }
    &.active{
      background-color:#0070eb;
      border-color:#0063d0;
      color:#fff;
    }
  }
}
.r-table-cont{
  margin-top:20px;
  .r-table-sections{
    display:flex;
    gap:5px;
    .r-table-section{
      color:#0070eb;
      cursor:pointer;
      &.active{
        font-weight: 700;
        color:#000;
      }
      &:hover{
        color:#000;
      }
      &:not(:last-child):after{
        content:"|";
        color:#000;
        padding-left:5px;
        font-weight: 400;
      }
    }
  }
}
.r-table{
  min-height: 150px;
  margin-top:20px;
  .r-table-row-wrapper {
    &:nth-child(odd){
      background-color:#f2f2f2;
    }

  }
  .r-table-row{
    width:100%;

    &.head{
      font-weight: 900;
      .r-table-col{
        font-size:16px;
        &:nth-child(4) {
        width:19.28%;
      }
        &:last-child{
          width:5%;
        }
      }
    }
    .r-table-col{
      display:inline-block;
      width:14.28%;
      padding:3px;
      font-size:12px;

      &:nth-child(4) {
        width:19.28%;
      }
      &:last-child{
        width:5%;
        text-align: center;
        i{
          cursor:pointer;
          font-size:22px;
          color:#0070eb;
        }
      }
    }
  }
}
.r-settings {
  margin-top:20px;
  .r-settings-section{
    margin-top:20px;
    textarea{
      width:420px;
      max-width: 420px;
      min-width: 420px;
      min-height: 100px;
      border:1px solid #ccc;
      padding:5px;
    }
    .r-section-head{
      font-weight: 900;
      border-bottom:1px solid #ccc;
      margin-bottom:20px;
    }
    .r-section-row{
      margin-top:20px;
      display:flex;
      .r-section-col{
        &:first-child{
        }
        h2{
          font-size:16px;
          padding:5px 20px;
        }
        .r-section-col-row{
          height: 35px;
          border-bottom:1px solid #ccc;
          margin-bottom:15px;
          display:flex;
          align-items: center;
          padding:5px 20px;
          label{
            cursor:pointer;
          }
          &.time{
            display:flex;
            gap:20px;
          }
        }
      }
    }
  }
}
.r-save-button{
  background-color:#0070eb;
  color:#fff;
  font-weight: 900;
  padding:5px 10px;
  width:max-content;
  cursor:pointer;
}
.r-cancel-button{
  background-color: darkred;
  color:#fff;
  font-weight: 900;
  padding:5px 10px;
  width:max-content;
  cursor:pointer;
}
.seating-cont{
  border:1px solid #ccc;
  margin:15px 0px;
  max-width:420px;
}
.seating-header{
  display:flex;
  padding:5px 10px;
  justify-content: space-between;
  background-color:#f2f2f2;
  border-bottom:1px solid #ccc;
  font-weight: 900;
  font-size:16px;
  color:#000;
  .seating-detail{
    display:flex;
    gap:5px;
    div:not(:last-child):after{
      content:"|";
      padding-left:5px;
    }
  }
}
.seating-body{
  padding:10px;
}
.seating-row{
  display:flex;
  gap:20px;
  width:100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom:15px;
  padding-bottom:5px;
  border-bottom:1px solid #ccc;
  &:last-child{
    margin-bottom:0px;
    padding-bottom:0px;
    border-bottom:0;
  }
  .seating-col{
    flex-basis:45%;
    select, input{
      width:100%;
      height: 35px;
      padding:5px;
    }
    &:first-child{
      font-weight: 900;
    }
  }
}
.add-seating{
  background-color:#000;
  color:#fff;
  width:max-content;
  padding:5px 10px;
  cursor:pointer;
}
.seating-options{
  display:flex;
  gap:20px;
  padding:10px;
  justify-content: flex-end;
  .r-save-button{
    background-color:#fff;
    border:1px solid #ccc;
    color:#000;
    font-weight: 400;
    &:hover{
      background-color:#0070eb;
      color:#fff;
    }
    &:last-child:hover{
      background-color:#ff2400;
      color:#fff;
    }
  }
}
.guest-details{
  border:1px solid #ccc;
  width:520px;
  padding:20px;
  margin:15px auto;
  .guest-details-row{
    display:flex;
    font-size:14px;
    justify-content: space-between;
    border-bottom:1px solid #ccc;
    &:last-child{
      flex-direction: column;
    }
    .guest-details-column{
      &:not(:last-child):after{
        content:":";
        padding-left:3px;
      }
      &:first-child{
        font-weight: bold;
      }
    }
  }
}
</style>
